var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditWs = function SvgEditWs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    d: "M3.693 13.013c-.406 0-.786-.14-1.06-.4-.346-.326-.513-.82-.453-1.353l.247-2.16c.046-.407.293-.947.58-1.24L8.48 2.067C9.847.62 11.273.58 12.72 1.947s1.487 2.793.12 4.24L7.367 11.98c-.28.3-.8.58-1.207.647l-2.147.366c-.113.007-.213.02-.32.02M10.62 1.94c-.513 0-.96.32-1.413.8l-5.474 5.8c-.133.14-.286.473-.313.667l-.247 2.16c-.026.22.027.4.147.513s.3.153.52.12l2.147-.367c.193-.033.513-.206.646-.346l5.474-5.794c.826-.88 1.126-1.693-.08-2.826-.534-.514-.994-.727-1.407-.727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A4",
    d: "M11.56 7.3h-.047A4.57 4.57 0 0 1 7.44 3.447a.51.51 0 0 1 .42-.574.51.51 0 0 1 .573.42 3.58 3.58 0 0 0 3.187 3.014.5.5 0 0 1 .447.546.516.516 0 0 1-.507.447"
  })));
};
export default SvgEditWs;